(function () {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(selector, root = document) {
    return root.querySelector(selector);
  }

  function qsa(selector, root = document) {
    return Array.from(root.querySelectorAll(selector));
  }

  function setHidden(element, hidden) {
    if (!element) return;
    element.hidden = hidden;
    element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }

  function initMobileMenu() {
    const toggle = qs('[data-mobile-menu-toggle]');
    const menu = qs('[data-mobile-menu]');
    const panel = qs('.mobile-menu__panel', menu || document);

    if (!toggle || !menu || !panel) return;

    let closeTimer = null;
    let lastActive = null;

    if (!panel.hasAttribute('tabindex')) {
      panel.setAttribute('tabindex', '-1');
    }

    function isMenuOpen() {
      return menu.classList.contains('is-open') || toggle.getAttribute('aria-expanded') === 'true';
    }

    function closeMenu() {
      if (!isMenuOpen()) return;

      window.clearTimeout(closeTimer);

      toggle.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('menu-open');

      closeTimer = window.setTimeout(() => {
        setHidden(menu, true);
      }, 180);

      if (lastActive && typeof lastActive.focus === 'function') {
        lastActive.focus();
      }
    }

    function openMenu() {
      window.clearTimeout(closeTimer);

      lastActive = document.activeElement;

      setHidden(menu, false);
      menu.setAttribute('aria-hidden', 'false');

      requestAnimationFrame(() => {
        toggle.setAttribute('aria-expanded', 'true');
        menu.classList.add('is-open');
        document.documentElement.classList.add('menu-open');
        panel.focus({ preventScroll: true });
      });
    }

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (isMenuOpen()) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    qsa('[data-mobile-menu-close]', menu).forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        closeMenu();
      });
    });

    menu.addEventListener('click', (event) => {
      if (!isMenuOpen()) return;

      const clickedInsidePanel = panel.contains(event.target);
      const clickedToggle = toggle.contains(event.target);

      if (!clickedInsidePanel && !clickedToggle) {
        closeMenu();
      }
    });

    panel.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    qsa('a', panel).forEach((link) => {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isMenuOpen()) {
        closeMenu();
      }
    });
  }

  function initSearchDrawer() {
    const panel = qs('[data-search-panel]');
    const input = qs('#HeaderSearch');

    if (!panel) return;

    function openSearch() {
      setHidden(panel, false);
      requestAnimationFrame(() => input?.focus());
    }

    function closeSearch() {
      setHidden(panel, true);
    }

    qsa('[data-search-toggle]').forEach((button) => {
      button.addEventListener('click', openSearch);
    });

    qsa('[data-search-close]').forEach((button) => {
      button.addEventListener('click', closeSearch);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) {
        closeSearch();
      }
    });
  }

  function initPcBuilderModal() {
    const modal = qs('[data-pc-builder-modal]');
    if (!modal) return;

    const panel = qs('.pc-builder-modal__panel', modal);
    const triggers = qsa('[data-pc-builder-open], a[href="#pc-builder"], a[href$="#pc-builder"]');

    let lastActive = null;
    let closeTimer = null;
    let scrollY = 0;

    if (panel && !panel.hasAttribute('tabindex')) {
      panel.setAttribute('tabindex', '-1');
    }

    function lockPageScroll() {
      scrollY = window.scrollY || document.documentElement.scrollTop || 0;

      document.documentElement.classList.add('pc-builder-open');
      document.body.classList.add('pc-builder-open');

      document.body.style.top = `-${scrollY}px`;
    }

    function unlockPageScroll() {
      document.documentElement.classList.remove('pc-builder-open');
      document.body.classList.remove('pc-builder-open');

      document.body.style.top = '';

      window.scrollTo(0, scrollY);
    }

    function closeBuilder() {
      window.clearTimeout(closeTimer);

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');

      unlockPageScroll();

      closeTimer = window.setTimeout(() => {
        setHidden(modal, true);
      }, 180);

      if (lastActive && typeof lastActive.focus === 'function') {
        lastActive.focus();
      }
    }

    function openBuilder(event) {
      event?.preventDefault?.();

      lastActive = document.activeElement;

      window.clearTimeout(closeTimer);

      setHidden(modal, false);
      modal.setAttribute('aria-hidden', 'false');

      lockPageScroll();

      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        panel?.focus?.({ preventScroll: true });
      });
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', openBuilder);
    });

    qsa('[data-pc-builder-close]', modal).forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        closeBuilder();
      });
    });

    modal.addEventListener('click', (event) => {
      const clickedInsidePanel = panel?.contains(event.target);

      if (!clickedInsidePanel) {
        closeBuilder();
      }
    });

    panel?.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeBuilder();
      }
    });
  }

  function initHoverTilt() {
    if (prefersReducedMotion || window.innerWidth < 990) return;

    qsa('.hover-tilt').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;

        card.style.transform = `perspective(900px) rotateX(${(-y * 5).toFixed(2)}deg) rotateY(${(x * 6).toFixed(2)}deg) translateY(-2px)`;
      });

      card.addEventListener('pointerleave', () => {
        card.style.transform = '';
      });
    });
  }

  function initBenchmarks() {
    const rows = qsa('.benchmark-row');
    if (!rows.length) return;

    const reveal = (row) => {
      const value = Number(row.dataset.benchmarkValue || 0);
      row.style.setProperty('--value', Math.max(0, Math.min(100, value)));
      row.classList.add('is-visible');
    };

    if (!('IntersectionObserver' in window)) {
      rows.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.28 });

    rows.forEach((row) => observer.observe(row));
  }

  function initAccordions() {
    qsa('[data-accordion-group]').forEach((group) => {
      qsa('details', group).forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;

          qsa('details', group).forEach((other) => {
            if (other !== details) other.open = false;
          });
        });
      });
    });
  }

  function initProductGallery() {
    qsa('[data-product-gallery]').forEach((gallery) => {
      const track = qs('[data-gallery-track]', gallery);
      const items = qsa('[data-gallery-item]', gallery);
      const thumbs = qsa('[data-gallery-thumb]', gallery);
      const prev = qs('[data-gallery-prev]', gallery);
      const next = qs('[data-gallery-next]', gallery);

      if (!items.length) return;

      let activeIndex = 0;
      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      function pauseMedia() {
        qsa('video', gallery).forEach((video) => {
          if (!video.paused) {
            video.pause();
          }
        });

        qsa('iframe', gallery).forEach((iframe) => {
          iframe.contentWindow?.postMessage?.('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
      }

      function updateThumbScroll() {
        const activeThumb = thumbs[activeIndex];

        if (!activeThumb) return;

        activeThumb.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }

      function goTo(index) {
        const total = items.length;

        if (!total) return;

        activeIndex = ((index % total) + total) % total;

        if (track) {
          track.style.transform = `translateX(-${activeIndex * 100}%)`;
        }

        items.forEach((item, itemIndex) => {
          const isActive = itemIndex === activeIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        thumbs.forEach((thumb, thumbIndex) => {
          const isActive = thumbIndex === activeIndex;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        pauseMedia();
        updateThumbScroll();
      }

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          goTo(Number(thumb.dataset.galleryThumb || 0));
        });
      });

      prev?.addEventListener('click', () => {
        goTo(activeIndex - 1);
      });

      next?.addEventListener('click', () => {
        goTo(activeIndex + 1);
      });

      gallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(activeIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(activeIndex + 1);
        }
      });

      if (track) {
        track.addEventListener('touchstart', (event) => {
          startX = event.touches[0].clientX;
          currentX = startX;
          isDragging = true;
        }, { passive: true });

        track.addEventListener('touchmove', (event) => {
          if (!isDragging) return;
          currentX = event.touches[0].clientX;
        }, { passive: true });

        track.addEventListener('touchend', () => {
          if (!isDragging) return;

          const diff = startX - currentX;

          if (Math.abs(diff) > 45) {
            if (diff > 0) {
              goTo(activeIndex + 1);
            } else {
              goTo(activeIndex - 1);
            }
          }

          isDragging = false;
        });
      }

      goTo(0);
    });
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';

    return new Intl.NumberFormat(document.documentElement.lang || 'es', {
      style: 'currency',
      currency
    }).format((Number(cents) || 0) / 100);
  }

  function initProductVariantSelect() {
    qsa('[data-product-section]').forEach((section) => {
      const select = qs('[data-product-variant-select]', section);
      const price = qs('[data-product-price] .price__current', section);
      const compare = qs('[data-product-price] .price__compare', section);
      const stock = qs('[data-product-stock]', section);
      const button = qs('[data-add-to-cart]', section);

      if (!select) return;

      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const available = option?.dataset.available === 'true';
        const optionPrice = Number(option?.dataset.price || 0);
        const compareAt = Number(option?.dataset.compareAt || 0);

        if (price) {
          price.textContent = formatMoney(optionPrice);
        }

        if (compare) {
          compare.textContent = compareAt > optionPrice ? formatMoney(compareAt) : '';
          compare.hidden = compareAt <= optionPrice;
        }

        if (stock) {
          stock.textContent = available ? 'Disponible para compra' : 'Producto agotado';
          stock.classList.toggle('is-sold-out', !available);
        }

        if (button) {
          button.disabled = !available;
          button.textContent = available ? 'Agregar al carrito' : 'Agotado';
        }
      });
    });
  }

  function initCodButtonDedupe() {
    function normalizeText(text) {
      return String(text || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function isVisible(element) {
      if (!element) return false;

      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        style.opacity !== '0' &&
        rect.width > 20 &&
        rect.height > 20
      );
    }

    function hasCodSignal(element) {
      if (!element) return false;

      const text = normalizeText(element.innerText || element.textContent || element.value || '');
      const aria = normalizeText(element.getAttribute('aria-label') || '');
      const title = normalizeText(element.getAttribute('title') || '');
      const id = normalizeText(element.id || '');
      const className = normalizeText(
        typeof element.className === 'string'
          ? element.className
          : element.getAttribute('class') || ''
      );
      const src = normalizeText(element.getAttribute('src') || '');
      const href = normalizeText(element.getAttribute('href') || '');

      const all = `${text} ${aria} ${title} ${id} ${className} ${src} ${href}`;

      return (
        all.includes('pagar contra reembolso') ||
        all.includes('contra reembolso') ||
        all.includes('pago contra reembolso') ||
        all.includes('cash on delivery') ||
        all.includes('releasit') ||
        all.includes('cod-form') ||
        all.includes('cod_form') ||
        all.includes('codbutton') ||
        all.includes('cod-button') ||
        all.includes('cod checkout') ||
        all.includes('cod')
      );
    }

    function getCodCandidates() {
      const selectors = [
        'button',
        'a',
        'input[type="button"]',
        'input[type="submit"]',
        'iframe',
        '[role="button"]',
        '[class*="releasit"]',
        '[id*="releasit"]',
        '[class*="cod"]',
        '[id*="cod"]',
        '[class*="COD"]',
        '[id*="COD"]'
      ].join(',');

      return qsa(selectors).filter((element) => {
        if (!isVisible(element)) return false;
        return hasCodSignal(element);
      });
    }

    function getBestWrapper(element) {
      const wrappers = [
        element.closest('[class*="releasit"]'),
        element.closest('[id*="releasit"]'),
        element.closest('[class*="cod"]'),
        element.closest('[id*="cod"]'),
        element.closest('[class*="COD"]'),
        element.closest('[id*="COD"]'),
        element.closest('.shopify-app-block'),
        element.closest('[data-shopify-editor-block]'),
        element.closest('[data-app-block]'),
        element.closest('form'),
        element.parentElement
      ].filter(Boolean);

      for (const wrapper of wrappers) {
        if (
          wrapper &&
          wrapper !== document.body &&
          wrapper !== document.documentElement &&
          !wrapper.matches('.product-info') &&
          !wrapper.matches('[data-product-section]')
        ) {
          return wrapper;
        }
      }

      return element;
    }

    function hideElement(element) {
      if (!element) return;

      element.style.setProperty('display', 'none', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('height', '0', 'important');
      element.style.setProperty('min-height', '0', 'important');
      element.style.setProperty('max-height', '0', 'important');
      element.style.setProperty('margin', '0', 'important');
      element.style.setProperty('padding', '0', 'important');
      element.style.setProperty('overflow', 'hidden', 'important');
      element.style.setProperty('opacity', '0', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
      element.setAttribute('aria-hidden', 'true');
      element.setAttribute('data-megav-cod-duplicate-hidden', 'true');
    }

    function removeDuplicateCodButtons() {
      const candidates = getCodCandidates();

      if (candidates.length <= 1) return;

      const wrappers = [];

      candidates.forEach((candidate) => {
        const wrapper = getBestWrapper(candidate);

        if (!wrappers.includes(wrapper)) {
          wrappers.push(wrapper);
        }
      });

      if (wrappers.length > 1) {
        wrappers.forEach((wrapper, index) => {
          if (index === 0) return;
          hideElement(wrapper);
        });

        return;
      }

      candidates.forEach((candidate, index) => {
        if (index === 0) return;
        hideElement(candidate);
      });
    }

    removeDuplicateCodButtons();

    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(removeDuplicateCodButtons);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'id', 'src', 'href']
    });

    window.setTimeout(removeDuplicateCodButtons, 100);
    window.setTimeout(removeDuplicateCodButtons, 300);
    window.setTimeout(removeDuplicateCodButtons, 800);
    window.setTimeout(removeDuplicateCodButtons, 1500);
    window.setTimeout(removeDuplicateCodButtons, 3000);
    window.setTimeout(removeDuplicateCodButtons, 5000);
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;

      if (!url || this.dataset.loaded === 'true') return;

      this.dataset.loaded = 'true';

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(() => {});
    }
  }

  function initCollectionFilters() {
    const toggles = qsa('[data-filter-toggle]');
    const panel = qs('[data-filter-panel]');

    if (toggles.length && panel && panel.dataset.drawerBound !== 'true') {
      panel.dataset.drawerBound = 'true';

      const dialog = qs('.collection-filters__panel', panel);
      let lastActive = null;

      if (dialog && !dialog.hasAttribute('tabindex')) {
        dialog.setAttribute('tabindex', '-1');
      }

      function setExpanded(expanded) {
        toggles.forEach((toggle) => {
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      }

      function openFilters(event) {
        event?.preventDefault?.();

        lastActive = document.activeElement;

        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('filters-open');

        setExpanded(true);

        requestAnimationFrame(() => {
          dialog?.focus?.({ preventScroll: true });
        });
      }

      function closeFilters() {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('filters-open');

        setExpanded(false);

        if (lastActive && typeof lastActive.focus === 'function') {
          lastActive.focus();
        }
      }

      toggles.forEach((toggle) => {
        toggle.addEventListener('click', openFilters);
      });

      qsa('[data-filter-close]', panel).forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          closeFilters();
        });
      });

      panel.addEventListener('click', (event) => {
        const clickedInsideDialog = dialog?.contains(event.target);

        if (!clickedInsideDialog) {
          closeFilters();
        }
      });

      dialog?.addEventListener('click', (event) => {
        event.stopPropagation();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && panel.classList.contains('is-open')) {
          closeFilters();
        }
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth >= 990 && panel.classList.contains('is-open')) {
          closeFilters();
        }
      });
    }

    bindCollectionAjax();
  }

  function bindCollectionAjax() {
    if (document.documentElement.dataset.collectionAjaxBound === 'true') return;

    document.documentElement.dataset.collectionAjaxBound = 'true';

    let controller = null;

    function getCollectionSection() {
      return qs('[data-collection-section]');
    }

    function buildUrlFromForm(form) {
      const url = new URL(form.getAttribute('action') || window.location.href, window.location.origin);
      const formData = new FormData(form);

      url.search = '';

      formData.forEach((value, key) => {
        const cleanValue = typeof value === 'string' ? value.trim() : value;

        if (cleanValue !== '' && cleanValue !== null) {
          url.searchParams.append(key, cleanValue);
        }
      });

      return url;
    }

    function setCollectionLoading(isLoading) {
      const section = getCollectionSection();

      if (!section) return;

      section.classList.toggle('is-loading', isLoading);
      section.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function refreshCollection(rawUrl, options = {}) {
      const section = getCollectionSection();

      if (!section) return Promise.resolve(false);

      const browserUrl = new URL(rawUrl, window.location.origin);
      const requestUrl = new URL(rawUrl, window.location.origin);
      const sectionId = section.dataset.collectionSection || section.dataset.collectionSectionId || section.id;

      if (sectionId) {
        requestUrl.searchParams.set('section_id', sectionId);
      }

      controller?.abort?.();
      controller = new AbortController();

      setCollectionLoading(true);

      return fetch(requestUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: controller.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error('Collection section request failed');
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const nextSection = qs('[data-collection-section]', doc) || doc;
          const currentSection = getCollectionSection();
          const wasOpen = qs('[data-filter-panel]')?.classList.contains('is-open');

          ['[data-collection-products]', '[data-active-filters]', '.sort-form', '[data-filter-panel]'].forEach((selector) => {
            const current = qs(selector, currentSection || document);
            const next = qs(selector, nextSection);

            if (current && next) {
              current.replaceWith(next);
            }
          });

          if (!options.skipHistory) {
            browserUrl.searchParams.delete('section_id');
            window.history.pushState({ megavCollection: true }, '', browserUrl.toString());
          }

          initCollectionFilters();

          if (wasOpen || options.keepFiltersOpen) {
            const panel = qs('[data-filter-panel]');

            if (panel) {
              panel.classList.add('is-open');
              panel.setAttribute('aria-hidden', 'false');
              document.documentElement.classList.add('filters-open');

              qsa('[data-filter-toggle]').forEach((toggle) => {
                toggle.setAttribute('aria-expanded', 'true');
              });
            }
          }

          const products = qs('[data-collection-products]');

          if (products && !options.keepFiltersOpen) {
            products.scrollIntoView({
              behavior: prefersReducedMotion ? 'auto' : 'smooth',
              block: 'start'
            });
          }

          return true;
        })
        .catch((error) => {
          if (error.name === 'AbortError') return false;
          return false;
        })
        .finally(() => {
          setCollectionLoading(false);
        });
    }

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-ajax-collection-form]');

      if (!form) return;

      event.preventDefault();

      refreshCollection(buildUrlFromForm(form), {
        keepFiltersOpen: form.classList.contains('filters-form')
      });
    });

    document.addEventListener('change', (event) => {
      const sortSelect = event.target.closest('[data-sort-select]');

      if (sortSelect && sortSelect.form) {
        event.preventDefault();
        refreshCollection(buildUrlFromForm(sortSelect.form));
      }
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-ajax-filter-link]');

      if (!link) return;

      event.preventDefault();

      refreshCollection(link.href, {
        keepFiltersOpen: Boolean(link.closest('.collection-filters'))
      });
    });

    window.addEventListener('popstate', () => {
      if (getCollectionSection()) {
        refreshCollection(window.location.href, { skipHistory: true });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('product-recommendations')) {
      customElements.define('product-recommendations', ProductRecommendations);
    }

    initMobileMenu();
    initSearchDrawer();
    initPcBuilderModal();
    initHoverTilt();
    initBenchmarks();
    initAccordions();
    initProductGallery();
    initProductVariantSelect();
    initCollectionFilters();
    initCodButtonDedupe();
  });
})();